import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { HelmetProvider } from "react-helmet-async";

// Performance: Use concurrent features
const root = document.getElementById("root")!;

createRoot(root).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
